import Cartao from '@/components/ui/Cartao';
import Chip from '@/components/ui/Chip';
import { formatarDinheiro } from '@/pages/gerenciar/utils';
import type { PainelPlataforma } from '../types';

interface TilesProps {
  totais: PainelPlataforma['totais'];
  pendencias: PainelPlataforma['pendencias'];
  mes: string;
  aviso: string;
}

interface ItemTile {
  rotulo: string;
  valor: string;
  extra?: string;
  tom?: 'padrao' | 'warning';
}

export default function Tiles({ totais, pendencias, mes, aviso }: TilesProps) {
  const pendentes: string[] = [];
  if (Number(pendencias.pix_rifa_sem_numero) > 0) {
    pendentes.push(`${pendencias.pix_rifa_sem_numero} Pix de ação entre amigos sem número`);
  }
  if (Number(pendencias.maquininhas_sem_evento) > 0) {
    pendentes.push(`${pendencias.maquininhas_sem_evento} maquininha(s) sem evento`);
  }
  if (Number(pendencias.repasse_sem_chave_pix) > 0) {
    pendentes.push(`${pendencias.repasse_sem_chave_pix} evento(s) com repasse e sem chave Pix`);
  }

  const tiles: ItemTile[] = [
    {
      rotulo: 'O Se Liga ganhou',
      valor: formatarDinheiro(totais.seliga_centavos),
      extra: `no mês ${mes}: ${formatarDinheiro(totais.seliga_mes_centavos)}`,
    },
    {
      rotulo: 'Está na conta do Se Liga',
      valor: formatarDinheiro(totais.na_conta_seliga_centavos),
    },
    {
      rotulo: 'A repassar',
      valor: formatarDinheiro(totais.a_repassar_centavos),
      tom: Number(totais.a_repassar_centavos) > 0 ? 'warning' : 'padrao',
    },
    {
      rotulo: 'A cobrar dos organizadores',
      valor:
        Number(totais.a_cobrar_centavos) === 0 ? '-' : formatarDinheiro(totais.a_cobrar_centavos),
    },
  ];

  return (
    <section>
      <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
        {tiles.map((t) => (
          <Cartao key={t.rotulo} className="flex min-w-0 flex-col p-4 md:p-5">
            <p className="text-xs font-medium text-foreground-600 md:text-sm">{t.rotulo}</p>
            <p
              className={`mt-2 whitespace-nowrap text-[28px] font-extrabold leading-none tabular-nums ${
                t.tom === 'warning' ? 'text-warning-700' : 'text-foreground-950'
              }`}
            >
              {t.valor}
            </p>
            {t.extra && (
              <p className="mt-2 text-xs text-foreground-500">{t.extra}</p>
            )}
          </Cartao>
        ))}
      </div>

      {aviso && (
        <p className="mt-3 flex items-start gap-2 text-sm text-foreground-600">
          <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-foreground-400">
            <i className="ri-information-line" />
          </span>
          <span className="min-w-0">{aviso}</span>
        </p>
      )}

      {pendentes.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {pendentes.map((texto) => (
            <Chip key={texto} tipo="warning">
              {texto}
            </Chip>
          ))}
        </div>
      )}
    </section>
  );
}